const stalker = document.getElementById('stalker');
const stalkerLeftArea = document.querySelectorAll('.custom-slick-prev');
const stalkerRightArea = document.querySelectorAll('.custom-slick-next');
const body = document.querySelector('body');

// in Area
stalkerLeftArea.forEach(function(element) {
  element.addEventListener('mousemove', function (e) {
    stalker.classList.remove('isInRight');
    stalker.classList.add('isInLeft');
    var posX = e.clientX - 32.5 // 中心をとるため
    var posY = e.clientY - 32.5 // 中心をとるため
    stalker.style.transform = 'translate(' + posX + 'px, ' + posY + 'px)';
    body.classList.add('cursorNone');
  });
})
stalkerRightArea.forEach(function(element) {
  element.addEventListener('mousemove', function (e) {
    stalker.classList.remove('isInLeft');
    stalker.classList.add('isInRight');
    var posX = e.clientX - 32.5 // 中心をとるため
    var posY = e.clientY - 32.5 // 中心をとるため
    stalker.style.transform = 'translate(' + posX + 'px, ' + posY + 'px)';
    body.classList.add('cursorNone');
  });
})

// out Area
stalkerLeftArea.forEach(function(element) {
  element.addEventListener('mouseout', function (e) {
    stalker.classList.remove('isInLeft');
    stalker.classList.remove('isInRight');
    body.classList.remove('cursorNone');
  });
})
stalkerRightArea.forEach(function(element) {
  element.addEventListener('mouseout', function (e) {
    stalker.classList.remove('isInLeft');
    stalker.classList.remove('isInRight');
    body.classList.remove('cursorNone');
  });
})